import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Divider,
  useTheme
} from '@mui/material';
import {
  CheckCircleOutline as CheckIcon,
  ShoppingBag as ShoppingBagIcon,
  Home as HomeIcon
} from '@mui/icons-material';

export default function OrderSuccess() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const order = location.state?.order;

  useEffect(() => {
    if (!order) {
      navigate('/');
    }
  }, [order, navigate]);

  if (!order) return null;

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <CheckIcon
          sx={{
            fontSize: 64,
            color: 'success.main',
            mb: 2
          }}
        />
        
        <Typography variant="h4" gutterBottom>
          {t('orderSuccess.title')}
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          {t('orderSuccess.subtitle')}
        </Typography>

        <Box sx={{ my: 4, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="h6" gutterBottom>
            {t('orderSuccess.orderId', { id: order.id })}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(order.paymentMethod === 'cash' 
              ? 'orderSuccess.paymentMessages.cash'
              : 'orderSuccess.paymentMessages.processed'
            )}
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
          >
            {t('orderSuccess.buttons.continueShopping')}
          </Button>
          <Button
            variant="contained"
            startIcon={<ShoppingBagIcon />}
            onClick={() => navigate('/profile', { state: { tabIndex: 2 } })}
          >
            {t('orderSuccess.buttons.viewOrders')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
} 